import { render, staticRenderFns } from "./LoyaltyPushRenderer.vue?vue&type=template&id=224fb56b&scoped=true&"
import script from "./LoyaltyPushRenderer.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyPushRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyPushRenderer.vue?vue&type=style&index=0&id=224fb56b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224fb56b",
  null
  
)

export default component.exports